module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/favicon_va.d445ddeb.svg";